module.exports = __webpack_public_path__ + "static/media/gallery7.9258f1f4.jpg";